module.exports = __webpack_public_path__ + "static/checklist-79d569d35d1ee74690876cee9ca84773.svg";